import React, { useId } from 'react';
import PropTypes from 'prop-types';

import { MAX_REASON_LENGTH, MIN_REASON_LENGTH } from './reason_rules';

// PROD-7828: mandatory operator note for payment-impacting edits, with its own inline error line.
// M4: a visible <label> when the caller names the field, else an aria-label from the placeholder so
// every existing caller (placeholder-only) still announces something; the error is linked via
// aria-describedby so a screen reader hears it, not just sees it.
function RequiredReasonTextarea(props) {
  const { value, onChange, name, placeholder, error, errorText, height, label } = props;
  const auto_id = useId();
  const field_id = name || auto_id;
  const error_id = `${field_id}-error`;
  return (
    <>
      <div style={{ margin: '10px 0' }}>
        {label ? (
          <label
            htmlFor={field_id}
            style={{ display: 'block', fontWeight: 600, marginBottom: '4px' }}
          >
            {label}
          </label>
        ) : null}
        <textarea
          id={field_id}
          value={value}
          name={name}
          onChange={onChange}
          style={{ width: '300px', height }}
          maxLength={MAX_REASON_LENGTH}
          placeholder={placeholder}
          aria-label={label ? undefined : placeholder}
          aria-describedby={error ? error_id : undefined}
        />
      </div>
      {error ? (
        <p id={error_id} style={{ color: 'var(--state-error)' }}>
          * {errorText || `A reason (at least ${MIN_REASON_LENGTH} characters) is required`}
        </p>
      ) : null}
    </>
  );
}

RequiredReasonTextarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  height: PropTypes.string,
  label: PropTypes.string
};

RequiredReasonTextarea.defaultProps = {
  value: '',
  name: undefined,
  placeholder: 'Reason (required)',
  error: false,
  errorText: '',
  height: '100px',
  label: ''
};

export default RequiredReasonTextarea;
